import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PopisMotoru = {
	name: NAME,
	apiProvider,
	router,
};
